import { renderTitleNames } from '@utils/notificationUtils'
import { useNavigate } from 'react-router-dom'
import { NotificationLikeIcon } from '../NotificationIcons'
import NotificationDisplay from '../NotificationDisplay'


const LikeDisplayByPost = ({ users, post }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/posts/${post.uuid}`, { state: { post }})
  }

  return (
    <NotificationDisplay
      Icon={NotificationLikeIcon}
      users={users}
      title={<span>{renderTitleNames(users)} liked your post</span>}
      body={post?.body}
      clickCallback={handleClick}
    />
  )
}

export default LikeDisplayByPost
